import { gsap } from './gsap';

class PageTransition {
  duration = 1;
  constructor($el) {
    this.$el = $el;
  }

  animateIn = (callback) => {
    const tl = gsap.timeline({
      onComplete: () => {
        if (callback) {
          callback();
        }
      },
    });

    tl.fromTo(this.$el, {
      x: '100%',
    },
    {
      x: '0%',
      duration: this.duration,
      ease: 'cubic-bezier(.165,.84,.44,1)',
    });
  }

  animateOut = () => {
    const tl = gsap.timeline();

    tl.fromTo(this.$el, {
      x: '0%',
    },
    {
      x: '-100%',
      duration: this.duration,
      ease: 'cubic-bezier(.165,.84,.44,1)',
    });
  }
}

export default new PageTransition($('[data-page-transition="el"]'));